export default () => {
  $('#buyer-agents-form').on('keypress', function (event) {
    if (event.keyCode === 13) {
      event.preventDefault()
      return false
    }
  })

  var areaOfServiceInput = document.getElementById('area_of_your_service')
  var options = {
    types: ['(regions)'],
    componentRestrictions: { country: 'au' },
  }
  const serviceInput = new google.maps.places.Autocomplete(
    areaOfServiceInput,
    options
  )

  google.maps.event.addListener(serviceInput, 'place_changed', () => {
    $('.search-input span.error').remove()
    let place = serviceInput.getPlace()
    console.log(place['formatted_address'])
    if (place['formatted_address'] == undefined) {
      $('.search-input').append(
        '<span class="error">Please enter a valid address and select from the list</span>'
      )
      $('.search-input').addClass('error')
      return
    } else {
      $('#area_of_your_service').before(
        `
            <li>
              <input type="text" value="${place['formatted_address']}">
              <a href="#" class="remove-item"></a>
            </li>
          `
      )
      $('input#area_of_your_service').val('')
      $('.search-input span.error').remove()
      $('.search-input').removeClass('error')

      initRemoveAddress()
    }
  })

  function initRemoveAddress() {
    $('.remove-item').on('click', function (event) {
      event.preventDefault()
      event.target.closest('li').remove()
    })
  }

  $('#slider-range').slider({
    range: true,
    min: 50000,
    max: 15000000,
    step: 25000,
    values: [50000, 15000000],
    animate: 'fast',
    slide: function (event, ui) {
      $('#price_range').val(
        '$' +
          ui.values[0].toLocaleString() +
          ' to $' +
          ui.values[1].toLocaleString()
      )
    },
  })
  $('#price_range').val(
    '$' +
      $('#slider-range').slider('values', 0).toLocaleString() +
      ' to $' +
      $('#slider-range').slider('values', 1).toLocaleString()
  )

  $('input#all_types').on('click', function (event) {
    if ($(this).is(':checked')) {
      $('.types-of-property-wrap input').prop('checked', true)
      $('span.error').remove()
    } else {
      $('.types-of-property-wrap input').prop('checked', false)
    }
  })
  $('.types-of-property-wrap input').on('change', function () {
    $('input#all_types').prop('checked', false)
  })

  $('#buyer-agents-form').on('submit', function (event) {
    event.preventDefault()

    $('label.error').remove()
    $('.errors-block').remove()
    $('.types-of-property span.error').remove()
    $('.search-input span.error').remove()
    $('.search-input').removeClass('error')

    let $form = $(this)

    $form.validate({
      rules: {
        company_name: {
          required: true,
          maxlength: 75,
          minlength: 1,
        },
        first_name: {
          required: true,
          maxlength: 50,
          minlength: 1,
        },
        last_name: {
          required: true,
          maxlength: 50,
          minlength: 1,
        },
        phone_number: {
          required: true,
          number: true,
        },
        email: {
          required: true,
          email: true,
          maxlength: 50,
          minlength: 1,
        },
      },
      messages: {
        company_name: {
          required: 'Please specify your company name',
        },
        first_name: {
          required: 'Please specify your fisrt name',
        },
        last_name: {
          required: 'Please specify your last name',
        },
        phone_number: {
          required: 'Please provide a phone number',
          number: 'Please enter a valid number (without +)',
        },
        email: {
          required: 'Please enter your email',
          email: 'Please enter a valid email address',
        },
      },
    })

    if (!$('input[name="types_of_property"]:checked').length) {
      $('.types-of-property').append(
        '<span class="error">Please select at least one type of property</span>'
      )
    } else {
      $('.types-of-property span.error').remove()
    }
    $('input[name="types_of_property"]').on('change', () => {
      if (!$('input[name="types_of_property"]:checked').length) {
        $('.types-of-property').append(
          '<span class="error">Please select at least one type of property</span>'
        )
      } else {
        $('.types-of-property span.error').remove()
      }
    })

    if (!$('.multiple-area-container li').length) {
      $('.search-input').append(
        '<span class="error">Please enter your service area</span>'
      )
      $('.search-input').addClass('error')
    } else {
      $('.search-input span.error').remove()
      $('.search-input').removeClass('error')
    }

    if (
      $form.valid() &&
      $('.multiple-area-container li').length &&
      $('.types-of-property input[type="checkbox"]:checked').length
    ) {
      const buyersData = []

      let $companyNameValue = $('input#company_name').val()
      let companyName = {
        name: 'company_name',
        value: $companyNameValue,
        meaning: 'Company Name',
      }

      let $firstNameValue = $('input#first_name').val()
      let firstName = {
        name: 'first_name',
        value: $firstNameValue,
        meaning: 'First Name',
      }

      let $lastNameValue = $('input#last_name').val()
      let lastName = {
        name: 'last_name',
        value: $lastNameValue,
        meaning: 'Last Name',
      }

      let $phoneNumberValue = $('input#phone_number').val()
      let phoneNumber = {
        name: 'phone_number',
        value: $phoneNumberValue,
        meaning: 'Phone Number',
      }

      let $emailValue = $('input#email').val()
      let email = {
        name: 'email',
        value: $emailValue,
        meaning: 'Email',
      }

      let areaValue = document.querySelectorAll(
        '.multiple-area-container input[type="text"]'
      )
      let areasOfService = ''
      for (let i = 0; i < areaValue.length; i++) {
        areasOfService += areaValue[i].value + '; '
      }
      let area = {
        name: 'area_of_your_service',
        value: areasOfService,
        meaning: 'Area Of Your Service',
      }

      let $priceRangeValue = $('input#price_range').val()
      let priceRange = {
        name: 'price_range',
        value: $priceRangeValue,
        meaning: 'Price Range',
      }

      let checkbox = document.querySelectorAll(
        '.types-of-property-wrap input[type="checkbox"]'
      )
      let typesOfProperty = ''
      for (let i = 0; i < checkbox.length; i++) {
        if (checkbox[i].checked) {
          typesOfProperty += checkbox[i].getAttribute('data-name') + '; '
        }
      }
      let propertyTypes = {
        name: 'types_of_property',
        value: typesOfProperty,
        meaning: 'Types Of Property',
      }

      buyersData.push(companyName)
      buyersData.push(firstName)
      buyersData.push(lastName)
      buyersData.push(phoneNumber)
      buyersData.push(email)
      buyersData.push(area)
      buyersData.push(priceRange)
      buyersData.push(propertyTypes)

      $.ajax({
        url: window.ajax_.ajax_url,
        type: 'POST',
        data: {
          action: 'sendBuyerAgentsForm',
          category: $form.data('category'),
          data: buyersData,
        },
        beforeSend: function () {
          $('.buyer-agents-overlay').addClass('opened')
          $('.buyer-agents-overlay .buyer-agents-loader').addClass('opened')
          console.log('waiting...')
        },
        success: function (response) {
          $('.buyer-agents-overlay .buyer-agents-loader').removeClass('opened')
          if (response.success) {
            $('.buyer-agents-overlay .buyer-agents-thank').addClass('opened')
            $('.buyer-agents-overlay').on('click', () => {
              $('.buyer-agents-overlay').removeClass('opened')
              $('.buyer-agents-overlay .buyer-agents-thank').removeClass(
                'opened'
              )
            })
            console.log('success')
          } else {
            $('.buyer-agents-overlay .buyer-agents-error').addClass('opened')
            $('.buyer-agents-overlay').on('click', () => {
              $('.buyer-agents-overlay').removeClass('opened')
              $('.buyer-agents-overlay .buyer-agents-error').removeClass(
                'opened'
              )
            })
            console.log('error')
          }
        },
        error: function (err) {
          $('.buyer-agents-overlay .buyer-agents-loader').removeClass('opened')
          $('.buyer-agents-overlay .buyer-agents-error').addClass('opened')
          $('.buyer-agents-overlay').on('click', () => {
            $('.buyer-agents-overlay').removeClass('opened')
            $('.buyer-agents-overlay .buyer-agents-error').removeClass('opened')
          })
          console.log(err)
        },
      })

      console.log(buyersData)
    } else {
      $('.contact-information').before(
        '<div class="errors-block"><span class="error">Please check the form for errors</span></div>'
      )
      window.scrollTo({
        top: 650,
        left: 0,
        behavior: 'smooth',
      })
      console.error('Please check the form for errors')
    }
  })
}
